import { StyleSheet, Platform } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export interface WelcomeRulesPhaseStyleOptions {
  scrollContentPaddingTop: number;
}

export const getWelcomeRulesPhaseStyles = (
  theme: Theme,
  options: WelcomeRulesPhaseStyleOptions,
) =>
  StyleSheet.create({
    phaseRoot: {
      flex: 1,
      ...(Platform.OS === 'web' && {
        minHeight: 0 as never,
        flexBasis: 0 as never,
      }),
    },
    scrollPhase: {
      flex: 1,
      ...(Platform.OS === 'web' && {
        minHeight: 0 as never,
      }),
    },
    scrollPhaseWeb: {
      height: '100%',
      ...(Platform.OS === 'web' && {
        overscrollBehavior: 'contain' as never,
        overscrollBehaviorY: 'contain' as never,
      }),
    },
    scrollContent: {
      paddingHorizontal: theme.spacing.xl,
      paddingTop: options.scrollContentPaddingTop,
      paddingBottom: theme.spacing.lg,
      ...(Platform.OS === 'web' && {
        maxWidth: 520,
        width: '100%',
        alignSelf: 'center' as const,
      }),
    },
    phaseLabel: {
      fontSize: 11,
      fontWeight: '700',
      letterSpacing: 2,
      textTransform: 'uppercase',
      marginBottom: theme.spacing.xs,
      color: theme.primary,
    },
    phaseTitle: {
      fontSize: theme.typography.h2.fontSize,
      fontWeight: '800',
      color: theme.black,
      marginBottom: theme.spacing.xs,
    },
    phaseSubtitle: {
      fontSize: theme.typography.bodySmall.fontSize,
      lineHeight: theme.typography.bodySmall.fontSize * 1.45,
      color: theme.gray[600],
      marginBottom: theme.spacing.lg,
    },
    sectionBlock: {
      marginBottom: theme.spacing.lg,
    },
    sectionHeaderRow: {
      flexDirection: 'row',
      gap: theme.spacing.md,
      alignItems: 'center',
      marginBottom: theme.spacing.sm,
    },
    sectionStepBadgeWrap: {
      width: 28,
      alignItems: 'center',
      flexShrink: 0,
    },
    sectionStepBadge: {
      width: 28,
      height: 28,
      borderRadius: 14,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.primary,
      shadowColor: theme.primary,
      shadowOpacity: 0.24,
      shadowRadius: 10,
      shadowOffset: { width: 0, height: 4 },
      elevation: 4,
    },
    sectionStepBadgeText: {
      color: theme.onPrimary,
      fontSize: 13,
      fontWeight: '800',
    },
    sectionTimelineLine: {
      width: 2,
      flex: 1,
      minHeight: 150,
      marginTop: theme.spacing.sm,
      borderRadius: theme.borderRadius.full,
      backgroundColor: theme.gray[200] + '85',
    },
    sectionTitleRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing.sm,
      flex: 1,
      minWidth: 0,
    },
    sectionIconWrap: {
      width: 28,
      height: 28,
      borderRadius: 14,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.primary + '14',
    },
    sectionTitle: {
      flex: 1,
      fontSize: theme.typography.label.fontSize,
      fontWeight: '700',
      color: theme.black,
    },
    sectionTitleEm: {
      color: theme.accent,
    },
    previewContent: {
      width: '100%',
      overflow: 'visible',
      /** Pull match / futures previews slightly past scroll padding for small screens */
      marginHorizontal: -theme.spacing.md,
    },
    footer: {
      paddingHorizontal: theme.spacing.xl,
      paddingTop: theme.spacing.md,
      paddingBottom: theme.spacing.md,
      borderTopWidth: StyleSheet.hairlineWidth,
      borderTopColor: theme.gray[200] + '85',
      backgroundColor: theme.background.primary,
      ...(Platform.OS === 'web' && {
        maxWidth: 520,
        width: '100%',
        alignSelf: 'center' as const,
      }),
    },
    ctaButton: {
      paddingVertical: theme.spacing.md,
      borderRadius: theme.borderRadius.md,
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'row',
      gap: theme.spacing.sm,
      backgroundColor: theme.primary,
    },
    ctaButtonPressed: {
      opacity: 0.88,
      transform: [{ scale: 0.98 }],
    },
    ctaButtonHovered: {
      opacity: 0.9,
    },
    ctaButtonLabel: {
      fontSize: theme.typography.label.fontSize,
      fontWeight: '700',
      color: theme.onPrimary,
    },
  });
